/** MUI helperText: show API/validation error first; else char count when within last 20% of max. */
export function fieldHelperText(error, maxLen, currentLen) {
  if (error) return error;
  if (maxLen > 0 && currentLen >= Math.ceil(maxLen * 0.8)) {
    return `${currentLen}/${maxLen}`;
  }
  return undefined;
}
